import { isProduction } from 'helpers/envInfo'


export const API_HOST = isProduction
    ? 'https://widget-api.outofmilk.com'
    : 'http://out-of-milk-oomhvr-oom-widgetapi.aws-sdlc-bonial.com'
